import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getDairyFeedInformation, getDairyFeedInformationAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_DAIRY_FEED_INFORMATION } from "consts";

export const useGetFootprintingDairyFeedInformationByPrimaryDataId = (feedInformationId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_DAIRY_FEED_INFORMATION, feedInformationId, isAdmin],
      queryFn: () => (isAdmin ? getDairyFeedInformationAdmin(feedInformationId) : getDairyFeedInformation(feedInformationId)),
      enabled: !!feedInformationId,
      gcTime: 60000,
    },
    queryClient
  );
};
